// New parsing helper producing raw tokens (without timestamps)
export function parseTextIntoTokens(raw: string): Array<{
  type: 'text' | 'punct';
  value: string;
}> {
  const result: Array<{ type: 'text' | 'punct'; value: string }> = [];
  let buffer = '';
  const flushWord = () => {
    if (!buffer) return;
    result.push({ type: 'text', value: buffer });
    buffer = '';
  };
  const punctSet = new Set([',', '.', '\n']);
  for (let i = 0; i < raw.length; i++) {
    const ch = raw[i];
    if (ch === ' ' || ch === '\t' || ch === '\r') {
      flushWord();
      continue;
    }
    if (punctSet.has(ch)) {
      flushWord();
      result.push({ type: 'punct', value: ch });
      continue;
    }
    buffer += ch;
  }
  flushWord();
  return result;
}
